<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="loco-status-container-data">
    <lms-loco-status-container-header [locoStatusArr]='locoStatusArr' (searchLocomotiveText)="updateSearchLocomotiveText($event);"></lms-loco-status-container-header>

    <lms-loco-status-container-data [locoStatusArr]='locoStatusArr' (updateDataStoreEventEmit)='updateDataStoreEvent($event);'
        (doubleEnterEventEmiiter)='doubleEnterEventEmiiter($event)' (locoSelectEvent)='locoSelectEvent()' [searchLocomotiveText]='searchLocomotiveText'
        (onLocoSelect)='showLocomotiveContextMenu($event);' (searchEventEmit)='searchEventEmit($event)' (removeLocoEventEmit)="removeLocoEventEmit($event)"></lms-loco-status-container-data>
</div>